module.exports = __webpack_public_path__ + "static/media/Java.57a00cb8.svg";